import { render, staticRenderFns } from "./IntGlobalUpdate.vue?vue&type=template&id=82b95fa4"
import script from "./IntGlobalUpdate.vue?vue&type=script&lang=js"
export * from "./IntGlobalUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports